<template>
  <div v-loading="loading">
    <el-card shadow="hover" style="padding: 10px 20px; min-height: 100px">
      <div v-if="orderInfo">
        <div v-if="isPaymentQuery" v-loading="isPaymentQuery">
          正在查询支付结果
        </div>
        <div
          v-else-if="orderInfo.optStatus == 1"
          style="color: #919191; font-size: 14px; font-weight: 400"
        >
          <div class="row">
            <div
              class="col-md-8 col-sm-8"
              style="background-color: #f1f1f1; padding: 30px"
            >
              <height-view :offsetSize="220">
                <div>
                  <span>订单编号</span>
                </div>
                <div
                  style="font-size: 22px; color: #919191; margin-bottom: 20px"
                >
                  <span>
                    {{ orderInfo.guid }}
                  </span>
                </div>
                <div>
                  <span>配送费用</span>
                </div>
                <div
                  style="font-size: 22px; color: #919191; margin-bottom: 20px"
                >
                  <span>
                    {{ orderInfo.freightAmount }}
                  </span>
                  <span> 元 </span>
                </div>
                <div>
                  <span>打包费用</span>
                </div>
                <div
                  style="font-size: 22px; color: #919191; margin-bottom: 20px"
                >
                  <span>
                    {{ orderInfo.packAmount }}
                  </span>
                  <span> 元 </span>
                </div>
                <div>
                  <span>优惠金额</span>
                </div>
                <div
                  style="font-size: 22px; color: #919191; margin-bottom: 20px"
                >
                  <span>
                    {{ orderInfo.discountAmount }}
                  </span>
                  <span> 元 </span>
                </div>
                <div>
                  <span>待收款金额</span>
                </div>
                <div>
                  <span style="font-size: 50px; color: #333333">
                    {{ orderInfo.totalAmount }}
                  </span>
                  <span style="font-size: 30px"> 元 </span>
                </div>
              </height-view>
            </div>
            <div class="col-md-4 col-sm-4">
              <div
                style="
                  font-size: 16px;
                  color: #333333;
                  margin-top: 20px;
                  margin-bottom: 30px;
                  text-align: center;
                "
              >
                <span>请在</span>
                <span style="color: #f56c6c">
                  {{
                    new Date(orderInfo.timeoutTime).format(
                      "YYYY-MM-dd hh:mm:ss"
                    )
                  }}
                </span>
                <span>前完成收款</span>
              </div>
              <el-empty
                :image="iconScan"
                :image-size="60"
                description="请出示付款码"
              ></el-empty>
            </div>
          </div>
        </div>
        <template v-else-if="isPaymentCancel">
          <el-result
            icon="error"
            title="订单已取消"
            subTitle="取消的订单不能收款了哦!"
          >
          </el-result>
        </template>
        <template v-else>
          <el-result
            icon="success"
            title="订单完成"
            :subTitle="'成功收款' + orderInfo.paymentAmount + '元'"
          >
          </el-result>
        </template>
      </div>
      <el-empty v-else-if="!loading" :description="errorMsg" :image-size="100">
        <el-button v-if="errorMsg" @click="getDetail" size="small">
          重新加载
        </el-button>
      </el-empty>
    </el-card>

    <el-dialog
      width="280px"
      :show-close="false"
      :append-to-body="true"
      :visible="dialogVisible"
      :title="payErrorMsg ? '提示' : '收款中'"
    >
      <template v-if="payIng">
        <div>正在收款中</div>
      </template>
      <template v-else-if="dialogVisible">
        <span>{{ payErrorMsg }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="dialogVisible = false">
            确 定
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import warehouseOrderInfo from '../../../../components/business/warehouseOrderInfo.vue';
import HeightView from '../../../../components/heightView.vue';

export default {
  components: {
    warehouseOrderInfo,
    HeightView,
  },
  props: {
    params: {
      type: Object,
      default: () => {
        return {};
      },
    },
    query: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  computed: {
    pageParams() {
      return Object.assign(
        {},
        (this.$route && this.$route.params) || {},
        this.params
      );
    },
    pageQuery() {
      return Object.assign(
        {},
        (this.$route && this.$route.query) || {},
        this.query
      );
    },
    isPaymentCancel() {
      if (!this.orderInfo) {
        return false;
      }
      return this.orderInfo.optCancel != 0
    },
    isPaymentQuery() {
      if (!this.orderInfo) {
        return false;
      }
      return this.orderInfo.optCancel == 1
        || this.orderInfo.optStatus == 2
        || this.orderInfo.optPayment == 4
    }
  },
  data() {
    return {
      loading: false,
      errorMsg: null,
      orderInfo: null,
      queryObj: null,
      payIng: false,
      payErrorMsg: "",
      dialogVisible: false,
      iconScan: require("./assets/ic_scan.png")
    }
  },
  methods: {
    doPayment(payCode) {
      if (this.payIng) {
        return;
      }
      this.payIng = true;
      this.payErrorMsg = null;
      this.dialogVisible = true;
      return this.requestApi('biz.warehouse.order.info.payment', {
        guid: this.orderInfo.guid,
        storeGuid: this.orderInfo.storeGuid,
        paymentBarcode: payCode,
      }).then(() => {
        this.getDetail();
      }).catch((err) => {
        this.payErrorMsg = (err && err.msg) || (err && err.message)
          || '连接服务器失败，请检查网络';
      }).finally(() => {
        this.payIng = false;
        this.dialogVisible = !!this.payErrorMsg;
      });
    },
    checkQuery() {
      if (this.queryObj) {
        return;
      }
      if (this.isPaymentQuery) {
        this.queryObj = setTimeout(() => {
          this.queryObj = null;
          this.getDetail();
        }, 1000);
      }
    },
    getDetail() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      this.errorMsg = null;
      this.orderInfo = null;
      return this.requestApi('biz.warehouse.order.info.query', {
        guid: this.pageParams.guid,
        storeGuid: this.pageParams.storeGuid
      }).then(() => {
        return this.requestApi('biz.warehouse.order.info.detail', {
          guid: this.pageParams.guid,
          storeGuid: this.pageParams.storeGuid
        })
      }).then((resp) => {
        this.orderInfo = resp.data;
        this.$drawer.refreshDrawer();
        this.checkQuery();
      }).catch((err) => {
        this.errorMsg = (err && err.msg) || (err && err.message)
          || '连接服务器失败，请检查网络';
      }).finally(() => {
        this.loading = false;
      });
    }
  },
  mounted() {
    this.onScan(this.doPayment);
    this.getDetail();
  },
  destroyed() {
    this.offScan(this.doPayment);
    if (this.queryObj) {
      clearTimeout(this.queryObj);
    }
  }
}
</script>